import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _actionDispatchMap;
import { BOTPRESS_INTERACTION_ACTIONS } from './BotpressInteraction.constants';
var OPEN_CHAT = BOTPRESS_INTERACTION_ACTIONS.OPEN_CHAT,
  SEND_MESSAGE = BOTPRESS_INTERACTION_ACTIONS.SEND_MESSAGE,
  SEND_EVENT = BOTPRESS_INTERACTION_ACTIONS.SEND_EVENT,
  NOTIFY = BOTPRESS_INTERACTION_ACTIONS.NOTIFY;
function handleOpenChat(methods) {
  methods.openChat();
}
function handleMesssage(methods, payload) {
  methods.sendMessage(payload);
}
function handleEvent(methods, payload) {
  methods.sendEvent(payload);
}

// TODO Discuss why we are needing two hooks, shouldn't we just have
//  the provider and it should be able to handle everything?
function handleNotification(methods, payload, notify) {
  var content = payload.content,
    options = payload.options;
  return notify(content, options);
}
var actionDispatchMap = (_actionDispatchMap = {}, _defineProperty(_actionDispatchMap, OPEN_CHAT, handleOpenChat), _defineProperty(_actionDispatchMap, SEND_MESSAGE, handleMesssage), _defineProperty(_actionDispatchMap, SEND_EVENT, handleEvent), _defineProperty(_actionDispatchMap, NOTIFY, handleNotification), _actionDispatchMap);
export function actionDispatch(methods, action, notify) {
  var type = action.type,
    payload = action.payload;
  var dispatchAction = actionDispatchMap[type];
  if (dispatchAction) {
    return dispatchAction(methods, payload, notify);
  }
  return null;
}